import { Link, Navigate } from "react-router-dom";
import { Clock, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/components/Brand";
import { LoadingState } from "@/components/common";
import { useAuth, homePathFor } from "@/context/AuthContext";
import { fmtDate } from "@/lib/format";
import { t } from "@/i18n";

export default function SignupStatus() {
  const { me, logout } = useAuth();
  if (me === undefined) return <LoadingState full />;
  if (!me) return <Navigate to="/login" replace />;
  const reqs = me.garage_requests || [];
  if (!reqs.length) return <Navigate to={homePathFor(me)} replace />;
  return (
    <AuthLayout title={t("p7.approval.statusTitle")}>
      <div className="space-y-4" data-testid="signup-status-page">
        {reqs.map((r) => (
          <div key={r.slug} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`signup-request-${r.slug}`}>
            <div className="flex items-center gap-3">
              {r.status === "rejected" ? <XCircle className="h-6 w-6 text-red-600" /> : <Clock className="h-6 w-6 text-amber-500" />}
              <p className="font-display text-xl font-bold text-slate-900">{r.garage_name}</p>
            </div>
            {r.status === "rejected" ? (
              <div className="mt-3 text-sm text-slate-700" data-testid="signup-request-rejected">
                <p>{t("p7.approval.rejected")}</p>
                {r.reason && <p className="mt-2 rounded-lg bg-red-50 p-3 text-red-800" data-testid="signup-request-reason">{r.reason}</p>}
              </div>
            ) : (
              <p className="mt-3 text-sm text-slate-700" data-testid="signup-request-pending">{t("p7.approval.pending")}</p>
            )}
            {r.requested_at && <p className="mt-3 text-xs text-slate-500">{t("p7.approval.requested", { date: fmtDate(r.requested_at) })}</p>}
          </div>
        ))}
        <Button variant="outline" onClick={logout} data-testid="signup-status-logout">{t("nav.logout")}</Button>
        <p className="text-xs text-slate-500"><Link to="/pricing" className="hover:text-slate-800">{t("p7.pricing.nav")}</Link></p>
      </div>
    </AuthLayout>
  );
}
